/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n="esri-compass",o={base:n,iconContainer:`${n}__icon-container`};export{o as css};
